const creatorPermissions = [
  "artwork_master.add_artworkmasterartworkname",
  "artwork_master.add_masterartworkname",
  "artwork_master.add_masterartworkcollection",
  "artwork_master.view_masterartworkcollection",
  "artwork_master.view_masterartworkname",
  "artwork_master.change_masterartworkcollection",
  "artwork_master.change_masterartworkname",
  ]

const approverPermissions=[
  ...creatorPermissions,
  "artwork_master.delete_masterartworkname",
  "artwork_master.delete_masterartworkcollection",
]

const artworkDesignGlobalPermissions: string[] = [...creatorPermissions];
const artworkDesignLocalPermissions: string[] = [...creatorPermissions];

const artworkMarketingGlobalPermissions: string[] = [...creatorPermissions];
const artworkMarketingLocalPermissions: string[] = [...creatorPermissions];

const artworkMasterDataLocalPermissions: string[] = [
  ...approverPermissions
];

const artworkMasterDataGlobalPermissions: string[] = [
  ...artworkDesignGlobalPermissions,
  ...artworkDesignLocalPermissions,
  ...artworkMarketingGlobalPermissions,
  ...artworkMarketingLocalPermissions,
  ...artworkMasterDataLocalPermissions,
];

export {
  artworkDesignGlobalPermissions,
  artworkDesignLocalPermissions,
  artworkMarketingGlobalPermissions,
  artworkMarketingLocalPermissions,
  artworkMasterDataLocalPermissions,
  artworkMasterDataGlobalPermissions,
  creatorPermissions, approverPermissions
};
